import React, { useEffect, useState } from 'react';
import { UmbracoProvider } from 'components/Umbraco/UmbracoContext';
import Layout from '../App/Layout'; 
import MultiStepForm from './components/MultiStepForm';
import { JoinHeader } from 'meitav-uikit';


const SITE_KEY = '6Ldle5QUAAAAAMt8wVG6frcFwZhFbuDakum6TcDB';

export default function JoinPersonalDetails() {
  useEffect(() => {
    const script = document.createElement("script");
    script.append(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-KZFXLQC');`);
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-KZFXLQC";
    iframe.height = "0";
    iframe.width = "0";
    iframe.style = "display:none;visibility:hidden";
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
  }, []);




  return (
    <UmbracoProvider umbracoUrl="/api/home/GetPage/JoinPersonalDetails/JoinPersonalDetailsPage">
      <Layout>
        <JoinHeader logo="manager"/>
            <MultiStepForm
            />
      </Layout>
    </UmbracoProvider>
  );
}
